// @ts-nocheck
import { useState, useEffect, useCallback } from "react"
import { supabaseClient } from "@/lib/supabase/client"

export function useComments(postId: string, userId: string | null) {
  const [comments, setComments] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [submitting, setSubmitting] = useState(false)

  const fetch = useCallback(async () => {
    setLoading(true)
    try {
      const { data } = await supabaseClient
        .from("comments")
        .select("*, users!comments_author_id_fkey(id, username, display_name, avatar_url, is_verified)")
        .eq("post_id", postId)
        .eq("status", "active")
        .order("created_at", { ascending: true })
      setComments(data || [])
    } finally { setLoading(false) }
  }, [postId])

  useEffect(() => { fetch() }, [postId])

  const addComment = useCallback(async (content: string, parentId?: string) => {
    if (!userId || !content.trim()) return false
    setSubmitting(true)
    try {
      const { data, error } = await supabaseClient.from("comments").insert({
        post_id: postId, author_id: userId, content: content.trim(),
        parent_id: parentId || null, status: "active"
      } as any).select("*, users!comments_author_id_fkey(id, username, display_name, avatar_url, is_verified)").single()
      if (error) throw error
      setComments(prev => [...prev, data])
      return true
    } catch { return false }
    finally { setSubmitting(false) }
  }, [postId, userId])

  const deleteComment = useCallback(async (commentId: string) => {
    await supabaseClient.from("comments").update({ status: "deleted" } as any).eq("id", commentId)
    setComments(prev => prev.filter(c => c.id !== commentId))
  }, [])

  return { comments, loading, submitting, addComment, deleteComment, refetch: fetch }
}
